<template>
  <div style="padding:10px;overflow:auto;height:76vh">
    <el-container>
      <el-header height="6vh">
        <el-button-group>
          <el-button type="danger" icon="el-icon-delete" @click="deletecontent()">删除</el-button>
          <el-button type="info" icon="el-icon-edit" @click="editsort()">修改排序</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="addContent()">添加</el-button>
        </el-button-group>
      </el-header>
      <el-main>
        <el-table
          ref="multipleTable"
          :data="contents"
          style="width: 100%"
          height="68vh"
          @selection-change="handleSelectionChange"
          :default-sort="{prop: 'sort', order: 'ascending'}"
        >
          <el-table-column type="selection" width="55" fixed></el-table-column>
          <el-table-column label="序号" width="50" type="index" fixed></el-table-column>
          <el-table-column label="排序" width="150" prop="sort">
            <template slot-scope="scope">
              <el-input-number v-if="sortShow" v-model="scope.row.sort" placeholder="顺序" />
              <span class="sorttext" title="修改排序" v-else @click="sortShow=true">{{scope.row.sort}}</span>
            </template>
          </el-table-column>
          <el-table-column label="标题" prop="title"></el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="editcontent(scope.row.id)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 添加修改区 开始 -->
        <add-list v-if="addShow" :Content="contentdata" @hide="hideListAdd" @refresh="fetchData"></add-list>
        <edit-list v-if="editShow" :Content="contentdata" @hide="hideListEdit" @refresh="fetchData"></edit-list>
      </el-main>
      <el-footer height="1vh" class="chead">
        <span>共{{totalcount}}条</span>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import {
  getList,
  editSort,
  getContent,
  deleteContents
} from "../../../api/gm/api-content";
import AddList from "./add";
import EditList from "./edit";
export default {
  //..数据
  data() {
    return {
      contents: [],
      addShow: false, //添加
      editShow: false, //修改
      sortShow: false,
      viewContentSearch: {
        productid: this.$route.params.id,
        relationid: this.$route.params.cid,
        relationmodel: "list",
        isdelete: false
      },
      totalcount: 0,
      contentdata: {
        id: 0,
        productid: this.$route.params.id,
        relationid: this.$route.params.cid,
        relationmodel: "list",
        title: "",
        info: "",
        sort: 1
      },
      multipleSelection: []
    };
  },
  components: {
    "add-list": AddList,
    "edit-list": EditList
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        this.viewContentSearch.productid = val.params.id;
        this.viewContentSearch.relationid = val.params.cid;
        this.contentdata.productid = val.params.id;
        this.contentdata.relationid = val.params.cid;
        this.fetchData();
      }
    }
  },
  methods: {
    //..table 选择
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //..隐藏添加框
    hideListAdd() {
      this.addShow = false;
    },
    //隐藏修改框
    hideListEdit() {
      this.editShow = false;
    },
    //..获取列表数据
    fetchData() {
      getList(this.viewContentSearch).then(res => {
        if (res.code === 0) {
          this.contents = res.data;
          this.totalcount = res.data.length;
        } else {
          console.log(res.msg);
        }
      });
    },
    //..添加内容
    addContent() {
      this.contentdata.id = 0;
      this.contentdata.productid = this.$route.params.id;
      this.contentdata.relationid = this.$route.params.cid;
      this.contentdata.relationmodel = "list";
      this.contentdata.title = "";
      this.contentdata.info = "";
      this.contentdata.sort = 1;
      this.addShow = true;
    },
    //..修改内容
    editcontent(id) {
      getContent(id).then(res => {
        if (res.code === 0) {
          this.contentdata.id = res.data.id;
          this.contentdata.productid = this.$route.params.id;
          this.contentdata.relationid = this.$route.params.cid;
          this.contentdata.relationmodel = "list";
          this.contentdata.title = res.data.title;
          this.contentdata.info = res.data.info;
          this.contentdata.sort = res.data.sort;
          this.editShow = true;
        } else {
          console.log(res.msg);
        }
      });
    },
    //..修改排序
    editsort() {
      let sortcontent = [];
      this.contents.forEach(item => {
        sortcontent.push({
          id: item.id,
          sort: item.sort
        });
      });
      editSort(sortcontent).then(res => {
        //this.fetchData();
        if (res.code === 0) {
          this.sortShow = false;
          this.$refs.multipleTable.sort("sort", "ascending");
          this.$message({
            message: res.msg,
            type: "success"
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //..删除数据
    deletecontent() {
      let ids = [];
      if (this.multipleSelection.length < 1) {
        this.$message.error("请选择要删除的数据");
      } else {
        this.multipleSelection.forEach(item => {
          ids.push(item.id);
        });
        this.$confirm("数据将彻底删除,确认?", "提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false,
          callback: action => {
            if (action === "confirm") {
              deleteContents(ids).then(res => {
                if (res.code === 0) {
                  this.fetchData();
                  this.$message({
                    message: res.msg,
                    type: "success"
                  });
                } else {
                  this.$message.error(res.msg);
                }
              });
            }
          }
        });
      }
    }
  }
};
</script>
<style scoped>
.chead {
  text-align: right;
}
.cheadl {
  text-align: left;
}
.sorttext {
  color: blue;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/pages/gm/content/list.vue